<template>
  <div id="spin-guided-creation-review-wrapper">
    <div id="section-one">
      <div id="heading-contact-location">
        <heading
          :heading="
            formatDate(
              event.date,
              event.time_zone ? event.time_zone.Name : undefined
            )
          "
          :subheading="headingSubheading"
        />
        <contact-list-item
          id="contact-list-item"
          :contact="chosenContact ? chosenContact : contactFields"
        />
        <map-display-with-details
          v-if="chosenLocation"
          :location="chosenLocation"
          :fetched="true"
          :deletable="false"
          :id="'location-map-detail'"
        />
      </div>
      <faux-paper id="invoice-display">
        <table class="faux-invoice">
          <tr v-for="product in event.invoice_products" :key="product.id">
            <td class="left-text">
              <p>{{ product.name }}</p>
            </td>
            <td class="center-text">
              <p>{{ eventTime }}</p>
            </td>
            <td class="right-text">
              <p>{{ productAmount(product) }}</p>
            </td>
          </tr>
          <tr class="divider">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <th class="left-text"><p>Subtotal:</p></th>
            <th></th>
            <th class="right-text">
              <p>{{ eventSubtotal }}</p>
            </th>
          </tr>
          <tr class="divider">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr
            v-for="(adjustment, index) in event.invoice_adjustments"
            :key="index"
          >
            <td class="left-text">
              <p>{{ adjustment.name }}</p>
            </td>
            <td></td>
            <td class="right-text">
              <p>
                {{ adjustmentAmount(adjustment) }}
              </p>
            </td>
          </tr>
          <tr class="divider">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <th class="left-text"><p>Total:</p></th>
            <th></th>
            <th class="right-text">
              <p>{{ eventTotal }}</p>
            </th>
          </tr>
        </table>
      </faux-paper>
    </div>
    <div id="section-two">
      <faux-paper id="inclusions-display">
        <table id="inclusions-table">
          <tr>
            <td><p class="right-text">Forms:</p></td>
            <td>
              <p class="left-text">
                {{ formNames }}
              </p>
            </td>
          </tr>
          <tr>
            <td><p class="right-text">Contracts:</p></td>
            <td>
              <p class="left-text">
                {{ contractNames }}
              </p>
            </td>
          </tr>
        </table>
      </faux-paper>
    </div>
  </div>
</template>
<script>
import {
  formatTime,
  formatPrice,
  formatDate,
  productTotal,
  subtotal,
  total,
  calculateEventTime,
} from "../../../../Helpers/invoice.js";
import ContactListItem from "../../../../Components/UI/ListItems/Contact/Search.vue";
import FauxPaper from "../../../../Components/UI/FauxPaper.vue";
import Heading from "../../../../Components/UI/Heading.vue";
import MapDisplayWithDetails from "../../../../Components/UI/ListItems/Location/MapDisplayWithDetails.vue";
export default {
  data() {
    return {};
  },
  computed: {
    formNames() {
      return this.event.forms.reduce((acc, cur) => {
        if (acc.length === 0) {
          return acc + cur.name;
        } else {
          return acc + ", " + cur.name;
        }
      }, "");
    },
    contractNames() {
      return this.event.contracts.reduce((acc, cur) => {
        if (acc.length === 0) {
          return acc + cur.contractName;
        } else {
          return acc + ", " + cur.contractName;
        }
      }, "");
    },
    eventTime() {
      return calculateEventTime(this.event) + " hours";
    },
    eventTotal() {
      return formatPrice(total(this.event));
    },
    eventSubtotal() {
      return formatPrice(subtotal(this.event));
    },
    headingSubheading() {
      return `${formatTime(
        this.event.start_time,
        this.event.time_zone ? this.event.time_zone.Name : undefined
      )} - ${formatTime(
        this.event.end_time,
        this.event.time_zone ? this.event.time_zone.Name : undefined
      )}`;
    },
  },
  methods: {
    formatDate,
    adjustmentAmount(adjustment) {
      return formatPrice(
        adjustment.type === "percentage"
          ? subtotal(this.event) * -adjustment.amount
          : adjustment.amount
      );
    },
    productAmount(product) {
      return formatPrice(productTotal(product, this.event));
    },
    next() {
      this.$emit("next");
    },
  },
  created() {},
  components: {
    // Button,
    ContactListItem,
    FauxPaper,
    Heading,
    MapDisplayWithDetails,
  },
  props: ["event", "chosenContact", "chosenLocation", "contactFields"],
  emits: ["next"],
};
</script>
<style scoped>
@media screen {
  #spin-guided-creation-review-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  #section-one,
  #section-two {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin: 10px 0;
  }

  #heading-contact-location {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  #heading-contact-location > div {
    margin: 8px 0;
  }

  #invoice-display {
    width: 100%;
    display: flex;
    overflow-y: scroll;
  }

  #inclusions-display {
    width: 100%;
  }

  .faux-invoice {
    border: 2px solid var(--contrastColor);
    margin: 40px;
    width: 100%;
    height: auto;
    border-radius: 4px;
    border-collapse: collapse;
  }

  .faux-invoice > * {
    border: 1px solid var(--contrastColor);
  }

  tr,
  th {
    height: 30px;
  }

  p {
    font-size: 0.7em;
    margin: 0 10px;
  }

  .left-text {
    text-align: left;
  }

  .right-text {
    text-align: right;
  }

  tr.divider {
    background-color: var(--contrastColor);
    height: 3px;
  }

  #inclusions-table {
    margin: 40px;
  }

  #submission-button {
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  @media (min-width: 800px) {
    #section-one,
    #section-two {
      flex-direction: row;
      justify-content: space-evenly;
      margin: 10px;
    }

    #section-one {
      align-items: flex-end;
    }

    #section-two {
      align-items: flex-start;
    }

    #heading-contact-location {
      width: 275px;
    }

    #heading-contact-location > div {
      margin: 8px;
    }

    #invoice-display {
      width: 50%;
    }

    #inclusions-display {
      height: 80%;
      width: 50%;
    }
  }
}
</style>
